
import { useState } from "react"
import {
  FaFacebookF,
  FaYoutube,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaSnapchat,

  FaPinterest,
 
} from "react-icons/fa"
import "../pages/master.css"
import logo from "../components/newservice/image/logo.jpeg"
import ServiceNew from "../components/newservice/ServiceNew"

import '../components/newservice/master1.css'
function Master() {
  const [formData, setFormData] = useState({
      name: "",
    phone: "",
    email: "",
    message: "",
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    console.log("Form submitted:", formData)
    fetch("https://portfolioback-nu.vercel.app/accontact", {
  
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
    alert("Form submitted successfully!")
    setFormData({ name: "",email: "",phone: "", message: "" })
  }

  return (
    <div className="app">
        {/* <NavBar/> */}
      <header>
        <div className="top-bar" style={{ background: "#080808ff", padding: "30px", zIndex: 2000 }}>
          <div className="container">
            <div className="contact-info">
              <a className='text-white' href="tel:+919199245536">+919199245536</a>
              <span className="divider">|</span>
              <a className='text-white' href="mailto:gyasuddinali0786@gmail.com">gyasuddinali0786@gmail.com</a>
            </div>
            <div className="social-icons">
              <a href="https://www.facebook.com/gyasusrkian91992" aria-label="Facebook">
                <FaFacebookF style={{color:'#d4af37'}}/>
              </a>
              <a href="#" aria-label="YouTube">
                <FaYoutube style={{color:'#d4af37'}}/>
              </a>
              <a href="https://www.twitter.com/iamgyasu" aria-label="Twitter">
                <FaTwitter style={{color:'#d4af37'}}/>
              </a>
              <a href="https://www.instagram.com/iam_gyasu/" aria-label="Instagram">
                <FaInstagram style={{color:'#d4af37'}}/>
              </a>
              <a href="#" aria-label="LinkedIn">
                <FaLinkedinIn style={{color:'#d4af37'}}/>
              </a>
              <a href="#" aria-label="Snapchat">
                <FaSnapchat style={{color:'#d4af37'}}/>
              </a>
             
              
              <a href="#" aria-label="Pinterest">
                <FaPinterest style={{color:'#d4af37'}}/>
              </a>
            </div>
          </div>
        </div>
        <nav className="main-nav">
          <div className="container">
            <div className="logo">
              <img src={logo} alt="One Stop Services Logo" className="img-fluid logo-img" style={{ maxWidth: '60px', height: 'auto' }}></img>
              <a href="/">
                <h1 className="h5 mb-0 text-dark">ONESTOPSERVICE
                </h1>
                <p  className="mb-0 small text-muted">All-in-One Services&Web Development

                </p>
              </a>
              
            </div>

<ServiceNew></ServiceNew>

          </div>
        </nav>
      </header>


      {/* <main>
        <section className="hero hero-bg">
          <h1 className="text-center mb-5 text-white">Welcome To OneStop Home Services & Web Development</h1>
          <div className="container">
            
            <div className="hero-content">
              
     <h2 className=" mb-3 fw-semibold text-warning" >From code to Home Services — we’ve got it covered</h2>

              <h1 className="text-warning">At your Siwan,Bihar</h1>
              <div className="course-features">
                <p style={{color:'InfoBackground'}}>
   We bring expert home services and digital solutions right to your doorstep. 
   From refreshing your space with
    a new coat of paint, deep-cleaning your home, fixing appliances, and solving
     plumbing issues, to building a stunning website, crafting engaging digital experiences, and boosting your online presence - we've got you covered. Our trusted professionals are committed to delivering top-quality work, on time, and with your satisfaction in mind. Let us handle the hard work, so you can enjoy a hassle-free, beautifully maintained home and a thriving online presence."


                </p>
              </div>
            </div>
            <div className="enrollment-form">
              <h3>Your Query in Our Servic</h3>
              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  placeholder="Your Name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
                <input
                  type="tel"
                  placeholder="Your Number"
                  name="number"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
                <input
                  type="email"
                  placeholder="Your Email Id"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                <textarea
                  placeholder="Comment or Message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>
                <button type="submit" className="submit-btn">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </section>


       

      </main> */}



  </div>
  )
}

export default Master

